import Vue from 'vue'
import Router from 'vue-router'
import AppSideBar from './components/AppSidebar.vue'


Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: [
    {
      path: '/',
      name: 'home',
      components: {
        landing: () => import('./views/Home.vue')
      }
    },
    {
      path: '/login',
      name: 'login',
      components: {
        login: () => import('./views/Login.vue')
      } 
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      components: {
        navbar: AppSideBar,
        content: () => import('./views/Dashboard.vue')
      } 
    },
    {
      path: '/signup',
      name: 'signUp',
      components: {
        content: () => import('./views/SignUp.vue')
      } 
    },
    {
      path: '/request-reset-password',
      name: 'requestResetPassword',
      components: {
        content: () => import('./views/RequestResetPassword.vue')
      } 
    },
    {
      path: '/reset-password',
      name: 'ResetPassword',
      components: {
        content: () => import('./views/ResetPassword.vue')
      } 
    },
    {
      path: '/member-management',
      name: 'memberManagement',
      components: {
        navbar: AppSideBar,
        content: () => import('./views/transaction/MemberManagement.vue')
      } 
    },
    {
      path: '/member-management/approvalbymember',
      name: 'memberApproval',
      components: {
        content: () => import('./views/MemberApproval.vue')
      } 
    },
    {
      path: '/member-management/detail',
      name: 'memberManagementDetail',
      components: {
        navbar: AppSideBar,
        content: () => import('./views/transaction/MemberManagementDetail.vue')
      } 
    },
    {
      path: '/user-profile',
      name: 'userProfile',
      components: {
        navbar: AppSideBar,
        content: () => import('./views/UserProfile.vue')
      } 
    },
    //master-data
    {
      path: '/customer',
      name: 'customer',
      components: {
        navbar: AppSideBar,
        content: () => import('./views/master/Customer.vue')
      } 
    },
    {
      path: '/customer/detail',
      name: 'customerDetail',
      components: {
        navbar: AppSideBar,
        content: () => import('./views/master/CustomerDetail.vue')
      } 
    },
    {
      path: '/supplier',
      name: 'supplier',
      components: {
        navbar: AppSideBar,
        content: () => import('./views/master/Supplier.vue')
      } 
    },
    {
      path: '/supplier/detail',
      name: 'supplierDetail',
      components: {
        navbar: AppSideBar,
        content: () => import('./views/master/SupplierDetail.vue')
      } 
    },
    {
      path: '/uom',
      name: 'uom',
      components: {
        navbar: AppSideBar,
        content: () => import('./views/master/UOM.vue')
      } 
    },
    {
      path: '/uom/detail',
      name: 'uomDetail',
      components: {
        navbar: AppSideBar,
        content: () => import('./views/master/UOMDetail.vue')
      } 
    },
    {
      path: '/expense',
      name: 'expense',
      components: {
        navbar: AppSideBar,
        content: () => import('./views/master/Expense.vue')
      } 
    },
    {
      path: '/expense/detail',
      name: 'expenseDetail',
      components: {
        navbar: AppSideBar,
        content: () => import('./views/master/ExpenseDetail.vue')
      } 
    },
    {
      path: '/treatment',
      name: 'treatment',
      components: {
        navbar: AppSideBar,
        content: () => import('./views/master/Treatment.vue')
      } 
    },
    {
      path: '/treatment/detail',
      name: 'treatmentDetail',
      components: {
        navbar: AppSideBar,
        content: () => import('./views/master/TreatmentDetail.vue')
      } 
    },
    {
      path: '/patient',
      name: 'patient',
      components: {
        navbar: AppSideBar,
        content: () => import('./views/master/Patient.vue')
      } 
    },
    {
      path: '/patient/detail',
      name: 'patientDetail',
      components: {
        navbar: AppSideBar,
        content: () => import('./views/master/PatientDetail.vue')
      } 
    },
    {
      path: '/supplies',
      name: 'supplies',
      components: {
        navbar: AppSideBar,
        content: () => import('./views/master/Supplies.vue')
      } 
    },
    {
      path: '/supplies/detail',
      name: 'suppliesDetail',
      components: {
        navbar: AppSideBar,
        content: () => import('./views/master/SuppliesDetail.vue')
      } 
    },
    //transaction
    {
      path: '/patientorthospace',
      name: 'patientOrthoSpace',
      components: {
        navbar: AppSideBar,
        content: () => import('./views/transaction/PatientOrthoSpace.vue')
      } 
    },
    {
      path: '/patientorthospace/detail',
      name: 'patientOrthoSpaceDetail',
      components: {
        navbar: AppSideBar,
        content: () => import('./views/transaction/PatientOrthoSpaceDetail.vue')
      } 
    },
    {
      path: '/patientorthodiagnose',
      name: 'patientOrthoDiagnose',
      components: {
        navbar: AppSideBar,
        content: () => import('./views/transaction/PatientOrthoDiagnose.vue')
      } 
    },
    {
      path: '/patientorthodiagnose/detail',
      name: 'patientOrthoDiagnoseDetail',
      components: {
        navbar: AppSideBar,
        content: () => import('./views/transaction/PatientOrthoDiagnoseDetail.vue')
      } 
    },
    //accounting
    {
      path: '/expense-form',
      name: 'expenseForm',
      components: {
        navbar: AppSideBar,
        content: () => import('./views/accounting/ExpenseForm.vue')
      } 
    },
    {
      path: '/expense-form/detail',
      name: 'expenseFormDetail',
      components: {
        navbar: AppSideBar,
        content: () => import('./views/accounting/ExpenseFormDetail.vue')
      } 
    },
    {
      path: '/medical-record/detail',
      name: 'medicalRecordDetail',
      components: {
        navbar: AppSideBar,
        content: () => import('./views/transaction/MedicalRecordDetail.vue')
      } 
    },
    {
      path: '/medical-record',
      name: 'medicalRecord',
      components: {
        navbar: AppSideBar,
        content: () => import('./views/transaction/MedicalRecord.vue')
      } 
    },
    {
      path: '/invoice/print',
      name: 'invoiceReport',
      components: {
        navbar: AppSideBar,
        content: () => import('./views/report/InvoiceReport.vue')
      } 
    },
    {
      path: '/invoice/detail',
      name: 'invoiceDetail',
      components: {
        navbar: AppSideBar,
        content: () => import('./views/transaction/InvoiceDetail.vue')
      } 
    },
    {
      path: '/invoice',
      name: 'invoice',
      components: {
        navbar: AppSideBar,
        content: () => import('./views/transaction/Invoice.vue')
      } 
    },
    // report
    {
      path: '/report/expense',
      name: 'reportExpense',
      components: {
        navbar: AppSideBar,
        content: () => import('./views/report/ExpenseReport.vue')
      } 
    },
    {
      path: '/report/income',
      name: 'reportIncome',
      components: {
        navbar: AppSideBar,
        content: () => import('./views/report/IncomeReport.vue')
      } 
    },
    {
      path: '/report/supplies',
      name: 'reportSupplies',
      components: {
        navbar: AppSideBar,
        content: () => import('./views/report/SuppliesReport.vue')
      } 
    }
  ]
})
